var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActionContainer)?_c('action-button',{attrs:{"title":"Related reactions","icon":_vm.$icons.react},on:{"action":_vm.action}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }